<template>
  <div id="app">
    <p-header :selectedPro="selectedPro" @selectedProChanged="selectedProChanged($event)"></p-header>
    <p-content :selectedPro="selectedPro" @openSlideover="openSlideover"></p-content>
    <p-slideover v-if="slideoverVisible" :visible="slideoverVisible" :entry="slideoverEntry" @closeSlideover="slideoverVisible = false"></p-slideover>
  </div>
</template>

<script>
import PHeader from './components/PHeader.vue';
import PContent from './components/PContent.vue';
import PSlideover from './components/PSlideover.vue'
export default {
  data() {
    return {
      selectedPro: true,
      slideoverVisible: false,
      slideoverEntry: undefined
    }
  },
  components: {
    'p-header': PHeader,
    'p-content': PContent,
    'p-slideover': PSlideover
  },
  methods: {
    selectedProChanged(value) {
      this.selectedPro = value;
    },
    openSlideover(entry) {
      this.slideoverEntry = entry;
      this.slideoverVisible = true;
    }
  }
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-dark);
  margin: 0;
  height: 100%;
}
</style>
